var map = {
	"./AutoScroll.page.json": "../../packages/api-docs/lib/pages/references/AutoScroll.page.json",
	"./Autofill.page.json": "../../packages/api-docs/lib/pages/references/Autofill.page.json",
	"./BaseComponent.page.json": "../../packages/api-docs/lib/pages/references/BaseComponent.page.json",
	"./Check.page.json": "../../packages/api-docs/lib/pages/references/Check.page.json",
	"./DateRangeType.page.json": "../../packages/api-docs/lib/pages/references/DateRangeType.page.json",
	"./DayOfWeek.page.json": "../../packages/api-docs/lib/pages/references/DayOfWeek.page.json",
	"./DelayedRender.page.json": "../../packages/api-docs/lib/pages/references/DelayedRender.page.json",
	"./EventGroup.page.json": "../../packages/api-docs/lib/pages/references/EventGroup.page.json",
	"./FabricPerformance.page.json": "../../packages/api-docs/lib/pages/references/FabricPerformance.page.json",
	"./FirstWeekOfYear.page.json": "../../packages/api-docs/lib/pages/references/FirstWeekOfYear.page.json",
	"./GlobalSettings.page.json": "../../packages/api-docs/lib/pages/references/GlobalSettings.page.json",
	"./IAccessiblePopupProps.page.json": "../../packages/api-docs/lib/pages/references/IAccessiblePopupProps.page.json",
	"./IAnimationStyles.page.json": "../../packages/api-docs/lib/pages/references/IAnimationStyles.page.json",
	"./IBaseProps.page.json": "../../packages/api-docs/lib/pages/references/IBaseProps.page.json",
	"./IChangeDescription.page.json": "../../packages/api-docs/lib/pages/references/IChangeDescription.page.json",
	"./IChangeEventCallback.page.json": "../../packages/api-docs/lib/pages/references/IChangeEventCallback.page.json",
	"./IComponentAs.page.json": "../../packages/api-docs/lib/pages/references/IComponentAs.page.json",
	"./IComponentAsProps.page.json": "../../packages/api-docs/lib/pages/references/IComponentAsProps.page.json",
	"./IDisposable.page.json": "../../packages/api-docs/lib/pages/references/IDisposable.page.json",
	"./IDragDropHelper.page.json": "../../packages/api-docs/lib/pages/references/IDragDropHelper.page.json",
	"./IEffects.page.json": "../../packages/api-docs/lib/pages/references/IEffects.page.json",
	"./IFontFace.page.json": "../../packages/api-docs/lib/pages/references/IFontFace.page.json",
	"./IFontStyles.page.json": "../../packages/api-docs/lib/pages/references/IFontStyles.page.json",
	"./IPalette.page.json": "../../packages/api-docs/lib/pages/references/IPalette.page.json",
	"./IRawFontStyle.page.json": "../../packages/api-docs/lib/pages/references/IRawFontStyle.page.json",
	"./IRawStyle.page.json": "../../packages/api-docs/lib/pages/references/IRawStyle.page.json",
	"./IRawStyleBase.page.json": "../../packages/api-docs/lib/pages/references/IRawStyleBase.page.json",
	"./IRectangle.page.json": "../../packages/api-docs/lib/pages/references/IRectangle.page.json",
	"./IRenderComponent.page.json": "../../packages/api-docs/lib/pages/references/IRenderComponent.page.json",
	"./IScheme.page.json": "../../packages/api-docs/lib/pages/references/IScheme.page.json",
	"./ISelectableDroppableTextProps.page.json": "../../packages/api-docs/lib/pages/references/ISelectableDroppableTextProps.page.json",
	"./ISemanticColors.page.json": "../../packages/api-docs/lib/pages/references/ISemanticColors.page.json",
	"./ISemanticTextColors.page.json": "../../packages/api-docs/lib/pages/references/ISemanticTextColors.page.json",
	"./ISize.page.json": "../../packages/api-docs/lib/pages/references/ISize.page.json",
	"./IStyle.page.json": "../../packages/api-docs/lib/pages/references/IStyle.page.json",
	"./IStyleBase.page.json": "../../packages/api-docs/lib/pages/references/IStyleBase.page.json",
	"./IStyleBaseArray.page.json": "../../packages/api-docs/lib/pages/references/IStyleBaseArray.page.json",
	"./IStyleFunction.page.json": "../../packages/api-docs/lib/pages/references/IStyleFunction.page.json",
	"./IStyleFunctionOrObject.page.json": "../../packages/api-docs/lib/pages/references/IStyleFunctionOrObject.page.json",
	"./ITheme.page.json": "../../packages/api-docs/lib/pages/references/ITheme.page.json",
	"./MonthOfYear.page.json": "../../packages/api-docs/lib/pages/references/MonthOfYear.page.json",
	"./Omit.page.json": "../../packages/api-docs/lib/pages/references/Omit.page.json",
	"./Point.page.json": "../../packages/api-docs/lib/pages/references/Point.page.json",
	"./Rectangle.page.json": "../../packages/api-docs/lib/pages/references/Rectangle.page.json",
	"./Selection.page.json": "../../packages/api-docs/lib/pages/references/Selection.page.json",
	"./TagPicker.page.json": "../../packages/api-docs/lib/pages/references/TagPicker.page.json",
	"./VerticalDivider.page.json": "../../packages/api-docs/lib/pages/references/VerticalDivider.page.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/@uifabric/api-docs/lib/pages/references sync \\w+\\.page\\.json$";